import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import axios from 'axios'
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from 'react-device-detect'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import Card, { CardContent, CardMedia } from 'material-ui/Card'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'

class Start extends Component {
  onMatch() {
    if (isBrowser) {
      window.open('https://www4.match.com/login/')
    }

    if (isMobile) {
      window.location.href = 'https://www4.match.com/login/'
    }
  }

  onPOF() {
    if (isBrowser) {
      window.open('https://www.pof.com/inbox.aspx')
    }

    if (isMobile) {
      window.location.href = 'https://www.pof.com/inbox.aspx'
    }
  }

  onZoosk() {
    if (isBrowser) {
      window.open('https://t.zoosk.com/login')
    }

    if (isMobile) {
      window.location.href = 'https://t.zoosk.com/login'
    }
  }

  onOkCupid() {
    if (isBrowser) {
      window.open('https://www.okcupid.com/profile')
    }

    if (isMobile) {
      window.location.href = 'https://www.okcupid.com/profile'
    }
  }

  constructor(props) {
    super(props)

    this.state = {
      match_username: 'Loading...',
      match_password: 'Loading...',
      pof_username: 'Loading...',
      pof_password: 'Loading...',
      zoosk_username: 'Loading...',
      zoosk_password: 'Loading...',
      okcupid_username: 'Loading...',
      okcupid_password: 'Loading...'
    }
  }

  componentDidMount() {
    let myComponent = this
    axios
      .get(
        `https://api.dsnapis.com/customer/${
          this.props.customer_number
        }/pw/teSt1`
      )
      .then(function(response) {
        if (response.data) {
          if (response.data[0]['Match_Email']) {
            myComponent.setState({
              match_username: response.data[0]['Match_Email'],
              match_password: response.data[0]['Match_PW'],
              pof_username: response.data[0]['POF_Email'],
              pof_password: response.data[0]['POF_PW'],
              zoosk_username: response.data[0]['Zoosk_Email'],
              zoosk_password: response.data[0]['Zoosk_PW'],
              okcupid_username: response.data[0]['OKC_Email'],
              okcupid_password: response.data[0]['OKC_PW']
            })
          }
        }
      })
  }

  render() {
    const { classes, theme, location } = this.props

    return (
      <div className={classes.root}>
        <Typography type="sub-heading" color="inherit" className={classes.text}>
          The profile section of the DSN App lets you go to any of your dating
          profiles all from one screen. Just tap a button below to see it in
          action.
        </Typography>
        <div>
          <Card className={classes.card}>
            <CardContent className={classes.content}>
              <Typography type="body2">MATCH.COM</Typography>
              <Typography>Your Match Login Details are:</Typography>
              <Typography>Username: {this.state.match_username}</Typography>
              <Typography>Password: {this.state.match_password}</Typography>
              <br />
              <Button onClick={() => this.onMatch()} raised color="primary">
                Go to Match
              </Button>
            </CardContent>
          </Card>
          <br />
          <Card className={classes.card}>
            <CardContent className={classes.content}>
              <Typography type="body2">POF.COM</Typography>
              <Typography>Your POF Login Details are:</Typography>
              <Typography>Username: {this.state.pof_username}</Typography>
              <Typography>Password: {this.state.pof_password}</Typography>
              <br />
              <Button onClick={() => this.onPOF()} raised color="primary">
                Go to POF
              </Button>
            </CardContent>
          </Card>
          <br />
          <Card className={classes.card}>
            <CardContent className={classes.content}>
              <Typography type="body2">ZOOSK.COM</Typography>
              <Typography>Your ZOOSK Login Details are:</Typography>
              <Typography>Username: {this.state.zoosk_username}</Typography>
              <Typography>Password: {this.state.zoosk_password}</Typography>
              <br />
              <Button onClick={() => this.onZoosk()} raised color="primary">
                Go to ZOOSK
              </Button>
            </CardContent>
          </Card>
          <br />
          <Card className={classes.card}>
            <CardContent className={classes.content}>
              <Typography type="body2">OKCUPID.COM</Typography>
              <Typography>Your OKCUPID Login Details are:</Typography>
              <Typography>Username: {this.state.okcupid_username}</Typography>
              <Typography>Password: {this.state.okcupid_password}</Typography>
              <br />
              <Button onClick={() => this.onOkCupid()} raised color="primary">
                Go to OkCupid
              </Button>
            </CardContent>
          </Card>
          <br />
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    changeRoute: url => dispatch(push(url))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(Start)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/MyProfiles/scenes/Start/index.js